import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { BusFormData } from '../../../../shared/models/bus-form-data';
import { AdminService } from '../../../admin/services/admin';
import { Entity } from '../../../../shared/models/entity';
import { Route } from '../../../../shared/models/route';
import { Partner } from '../../../../shared/models/partner';

@Component({
  selector: 'app-bus-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatSelectModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent],
  templateUrl: './bus-form.html',
  styleUrl: './bus-form.css'
})
export class BusForm implements OnInit {
    busForm    : FormGroup;
    isEditMode : boolean   = false;
    entities   : Entity[]  = [];
    routes     : Route[]   = []; 
    partners   : Partner[] = [];
    private _busIdToUpdate: string | null =  null;

    constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<BusForm, BusFormData | undefined>, @Inject(MAT_DIALOG_DATA) public data: BusFormData | null, private adminService: AdminService) {
        this.isEditMode = !!data;

        if(this.isEditMode) {
            this._busIdToUpdate = data?.id || null;
        }
        
        this.busForm = this.fb.group({
            name: [data?.name || '', [Validators.required]],
            licensePlate: [data?.licensePlate || '', [Validators.required]],
            status: [data?.status ?? true],
            partnerId: [data?.partnerId || '', [Validators.required]],
            routeId: [data?.routeId || '', [Validators.required]],
            entityId: [data?.entityId || '', [Validators.required]]
        });
    }

    ngOnInit(): void {
        this.loadRelatedData();
    }

    async loadRelatedData(): Promise<void> {
        const entitiesResult = await this.adminService.getAllEntities();

        if(entitiesResult) {
            this.entities = entitiesResult;
        }

        const routesResult = await this.adminService.getAllRoutes();

        if(routesResult) {
            this.routes = routesResult;
        }

        const partnersResult = await this.adminService.getAllPartners();

        if(partnersResult) {
            this.partners = partnersResult;
        }
    }

    get nameControl() {
        return this.busForm.get('name');
    }

    get licensePlateControl() {
        return this.busForm.get('licensePlate');
    }

    get partnerIdControl() {
        return this.busForm.get('partnerId');
    }

    get routeIdControl() {
        return this.busForm.get('routeId');
    }

    get entityIdControl() {
        return this.busForm.get('entityId');
    }

    onSubmit(): void {
        this.busForm.markAllAsTouched();

        if(this.busForm.valid) {
            const formData = this.busForm.value;
            let resultData : BusFormData;

            if(this.isEditMode && this._busIdToUpdate) {
                resultData = { ...formData, id: this._busIdToUpdate } as BusFormData;
            } else {
                resultData = formData as BusFormData;
            }

            this.dialogRef.close(resultData);
        }
    }

    onCancel(): void {
        this.dialogRef.close(undefined);
    }
}